import { L1ObjectObjective } from 'core/l1Object/L1Object';
import { DefaultRtbCampaignBasicFormModel } from './RtbCampaignBasicFormModel';
import {
  RtbCampaignPlanType,
  ViewTrackingTrigger,
  ViewTrackingType
} from 'core/rtbCampaign/RtbCampaign';
import { L2ObjectOptimizationGoal } from 'core/l2Object/L2Object';
import {
  LIMITATION_TYPE,
  LimitationInventorySettings
} from 'containers/Limitations/LimitationSetting/limitationConfig/limitationSettingsType';
import { getRtbOutdoorLimitationInventorySettings } from 'containers/Limitations/LimitationSetting/limitationConfig/outdoorLimitationInventorySettings';
import i18n from 'i18n';
import { OPERATE } from 'enum/Operate';

export abstract class AbstractOutdoorCampaignFormModel extends DefaultRtbCampaignBasicFormModel {
  override get onlyBidCap(): boolean {
    return true;
  }

  override async init() {
    /* no-op */
  }

  override getRtbOptionsMap() {
    const optionsMap = {
      [L1ObjectObjective.AWARENESS]: {
        [RtbCampaignPlanType.RS]: [
          L2ObjectOptimizationGoal.IMPRESSIONS,
          L2ObjectOptimizationGoal.VIDEO_VIEWS
        ],
        [RtbCampaignPlanType.FCPM]: [L2ObjectOptimizationGoal.IMPRESSIONS],
        [RtbCampaignPlanType.FCPV]: [L2ObjectOptimizationGoal.VIDEO_VIEWS]
      },
      [L1ObjectObjective.TRAFFIC]: {},
      [L1ObjectObjective.SALES]: {},
      [L1ObjectObjective.UNSPECIFIED]: {
        [RtbCampaignPlanType.FCPM]: [L2ObjectOptimizationGoal.IMPRESSIONS]
      }
    };
    return this.filterOptionsMapByPricingMode(
      optionsMap,
      this.l1Object.channelGroupId
    );
  }

  override getLimitationInventorySetting(requiredOperateOfTaTypes: {
    [key: string]: string[];
  }): LimitationInventorySettings[] {
    const inventorySettings = getRtbOutdoorLimitationInventorySettings(
      requiredOperateOfTaTypes,
      LIMITATION_TYPE.CAMPAIGN,
      this.l1Object.channelGroupId,
      this.campaignAdType,
      this.l1Object.channel
    );

    const spaceSetting = inventorySettings.find(
      (setting) => setting.name === 'adspace'
    );
    if (spaceSetting) {
      spaceSetting.requiredOperate = [OPERATE.INCLUDE];
    }
    return inventorySettings;
  }

  override getThirdPartyTrackingTypeOptions() {
    return [
      {
        label: i18n.t(
          'campaign.strategyAndTracking.thirdPartyTrackingTypePixel'
        ),
        value: ViewTrackingType.PIXEL
      }
    ];
  }

  override getThirdPartyTriggerTypeOptions() {
    return [
      {
        label: i18n.t('campaign.strategyAndTracking.impressionTrigger'),
        value: ViewTrackingTrigger.IMPRESSION
      }
    ];
  }
}
